import { orderBy } from 'lodash';

import { IClustersListItem } from 'components/pages/DurationForecastPage/DurationForecastPage.type';

export const sortClusters = ({
    clustersList,
    sortAscending,
    sortByKey,
}: {
    clustersList: IClustersListItem[];
    sortAscending: boolean;
    sortByKey: (item: IClustersListItem) => string | number;
}): IClustersListItem[] => {
    if (!clustersList) return [];
    return orderBy(clustersList, [sortByKey], [sortAscending ? 'asc' : 'desc']);
};
